import { fetchAuthSession } from "@aws-amplify/auth";
import axios, { AxiosPromise, InternalAxiosRequestConfig } from "axios";

import { envConfig } from "config/env";

export const apiClient = axios.create({
	baseURL: envConfig.API_URL,
	params: {},
	headers: {},
});

const cognitoInterceptor = async (request: InternalAxiosRequestConfig) => {
	const { tokens } = await fetchAuthSession().catch(() => ({ tokens: undefined }));
	if (request.headers && tokens?.idToken) request.headers["Authorization"] = `Bearer ${tokens.idToken.toString()}`;
	return request;
};

console.log("Adding default cognito interceptor");
apiClient.interceptors.request.use(cognitoInterceptor);

export type CustomAxiosRequest<I, O> = (args: I) => AxiosPromise<O>;
